import { Injectable } from '@angular/core';
import { Headers, Http, Response, ResponseContentType, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import * as FileSaver from 'file-saver';
import { process } from '../../components/process/process.listener';

@Injectable()
export class ApiEvsService {
  private header: Headers;
  private endPoint: string;
  private endPointAdd: string;

  constructor(
    public http: Http,
    public router: Router
  ) {
    this.header = new Headers();
  }

  public setHeader(key: string, value: string): ApiEvsService {
    this.header.set(key, value);
    return this;
  }

  public setEndPoint(s: string) {
    this.endPoint = s;
  }

  login(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    return this.http
      .post(environment.api_evs + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  get(url: string, options?: any): Observable<any> {
    const params = new URLSearchParams();
    if (typeof options === 'object') {
      for (const i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    // console.log(environment.api_evs + url)
    return this.http
      .get(environment.api_evs + url, { headers: this.header, search: params })
      .map((res: any) => {
        return this.check(res);
      })
      .catch((error: any) => {
        console.log(error);
        throw this.checkErr(error);
      });
  }

  getServer(url: string, options?: any): Observable<any> {
    const params = new URLSearchParams();
    if (typeof options === 'object') {
      for (const i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http
      .get(environment.api_evs + url, { headers: this.header, search: params })
      .map((res: any) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  getNoToken(url: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    const params = new URLSearchParams();
    if (typeof options === 'object') {
      for (const i in options) {
        params.set(i, options[i]);
      }
    }
    return this.http
      .get(environment.api_evs + url, { headers: this.header, search: params })
      .map((res: any) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  getFullUrl(url_api: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http
      .get(url_api, { headers: this.header })
      .map((res: any) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error;
      });
  }

  getFromiCheck(url_api: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    const params = new URLSearchParams();
    if (typeof options === 'object') {
      for (const i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    this.header.set('Authorization', 'Basic aWNoZWNrOmlZQUYmO2NCZSNHM2F+RDojaGVjaw==');
    return this.http
      .get(url_api, { headers: this.header, search: params })
      .map((res: any) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  post(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http
      .post(environment.api_evs + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  postServer(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http
      .post(environment.api_evs + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  postFullUrl(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http
      .post(url, body, { headers: this.header })
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error;
      });
  }

  postNoToken(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    return this.http
      .post(environment.api_evs + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  put(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http
      .put(environment.api_evs + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => Observable.throw(this.checkErr(error) || 'Server error'));
  }

  putServer(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http
      .put(environment.api_evs + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => Observable.throw(this.checkErr(error) || 'Server error'));
  }

  delete(url: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http
      .delete(environment.api_evs + url, {
        headers: this.header,
        search: options,
      })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => Observable.throw(this.checkErr(error) || 'Server error'));
  }

  deleteServer(url: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http
      .delete(environment.api_evs + url, {
        headers: this.header,
        search: options,
      })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => Observable.throw(this.checkErr(error) || 'Server error'));
  }

  multiPost(url: string, data: {}): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http
      .post(environment.api_evs + url, data, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  all(data?: {}, params?: any) {
    return this.get(this.endPoint, data);
  }

  find(id, data?: {}) {
    return this.get(this.endPoint + '/' + id, data);
  }

  add(data: {}) {
    return this.post(this.endPointAdd, data);
  }

  update(id, data: {}) {
    return this.put(this.endPoint + '/' + id, data);
  }

  remove(id, data?: {}) {
    return this.delete(this.endPoint + '/' + id, data);
  }

  check(res) {
    const response = res.json() ? res.json() : true;
    let status;
    if (response.hasOwnProperty('statusCode')) {
      status = response.statusCode;
    }
    if (response.hasOwnProperty('status')) {
      status = response.status;
    }
    if (status == 200 || status == 201) {
      return response;
    } else if (status == 400) {
      throw res;
    } else if (status == 401) {
      this.router.navigate(['/page-401']);
      throw res;
    } else if (status == 403) {
      localStorage.removeItem('Access-Token');
      localStorage.removeItem('Access-Token-Icheck');
      this.router.navigate(['/login']);
    } else if (status == 406) {
      this.router.navigate(['/permission/error']);
      throw res;
    } else if (status == 204) {
      return true;
    } else if (status == 422) {
      let errorValidation = {
        status: status,
        error: true,
        message: 'Invalid input data!',
      };
      if (response.hasOwnProperty('validationErrors') && response.validationErrors.length > 0) {
        for (let i = 0; i < response.validationErrors.length; i++) {
          errorValidation.message += response.validationErrors[i].message + '\n';
        }
      }
      throw errorValidation;
    } else {
      throw res;
    }
  }

  checkErr(err) {
    const errorRes = err.json();
    let status;
    if (errorRes.hasOwnProperty('statusCode')) {
      status = errorRes.statusCode;
    }
    if (errorRes.hasOwnProperty('status')) {
      status = errorRes.status;
    }
    if (errorRes.hasOwnProperty('data')) {
      // for api register of icheck
      if (errorRes.data.hasOwnProperty('status')) {
        status = errorRes.data.status;
      }
    }

    if (status == 200 || status == 201) {
      if (status == 401) {
        throw errorRes;
      } else if (errorRes.data) {
        return errorRes.data;
      } else {
        return true;
      }
    } else if (status == 400) {
      throw errorRes;
    } else if (status === 401) {
      // console.log(err);
      this.router.navigate(['/page-401']);
      throw errorRes;
    } else if (status == 403) {
      localStorage.removeItem('Access-Token');
      localStorage.removeItem('Access-Token-Icheck');
      this.router.navigate(['/login']);
    } else if (status == 404) {
      throw { message: 'Không có dữ liệu.' };
    } else if (status == 406) {
      this.router.navigate(['/permission/error']);
      throw errorRes;
    } else if (status == 204) {
      return true;
    } else if (status == 422) {
      let errorValidation = {
        status: status,
        error: true,
        message: 'Invalid input data!',
      };
      if (errorRes.hasOwnProperty('validationErrors') && errorRes.validationErrors.length > 0) {
        errorValidation.message = '';
        for (let i = 0; i < errorRes.validationErrors.length; i++) {
          errorValidation.message += errorRes.validationErrors[i].message + '<br>';
        }
      }
      throw errorValidation;
    }
    {
      const mess_xxx = errorRes.message
        ? errorRes.message
        : 'Có lỗi xảy ra trong quá trình lấy thông tin. Vui lòng thử lại sau.';
      throw { message: mess_xxx };
    }
  }

  getexcel(url: string, name: string = '', method: string = 'GET', query?: any, body?: any) {
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
      this.header.append('Accept', 'application/octet-stream');
    }
    const name2 = name.replace(' ', '-');
    const params = new URLSearchParams();
    if (query) {
      if (typeof query === 'object') {
        for (const i in query) {
          params.set(i, query[i]);
        }
      }
    }

    if (method === 'GET') {
      this.http
        .get(environment.api_evs + url, {
          headers: this.header,
          search: params,
          responseType: ResponseContentType.ArrayBuffer,
        })
        .map((res: any) => {
          return res;
        })
        .subscribe(
          data => {
            const blob = new Blob([data._body], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            FileSaver.saveAs(blob, name2 + '.xlsx');
          },
          err => {
            console.error(err);
          },
          () => {
            process.onRemoveDownloadProcess.emit();
          }
        );
    } else if (method === 'POST') {
      this.http
        .post(environment.api_evs + url, body, {
          headers: this.header,
          search: params,
          responseType: ResponseContentType.ArrayBuffer,
        })
        .map((res: any) => {
          return res;
        })
        .subscribe(
          data => {
            const blob = new Blob([data._body], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            FileSaver.saveAs(blob, name2 + '.xlsx');
          },
          err => {
            console.error(err);
          },
          () => {
            process.onRemoveDownloadProcess.emit();
          }
        );
    }
  }

  public loginFB(token_icheck) {
    const body = {
      icheck_token: token_icheck,
      ttl: 31556926,
    };
    return this.http
      .post(environment.api_evs + '/login/token', body)
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  public streamFile(url) {
    return this.http.get(environment.api_evs + url, {
      responseType: ResponseContentType.Blob,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/ApiEvs.service.ts